<template>
     <v-card  elevation="16" variant="outlined" class="mx-auto my-8">
          <v-card-item>
         
     <v-card-text>
  <v-container >
    <v-list>
        <v-list-item>
            <v-btn router :to='"/constantes/"+this.$route.params.id'
      color="blue-darken-4" class="text-none ms-4 text-white">
      Constantes
    </v-btn>
        </v-list-item>
        <v-list-item>
            <v-btn router :to='"/observation/"+this.$route.params.id'
      color="blue-darken-4" class="text-none ms-4 text-white">
      Observations
    </v-btn>
        </v-list-item>
        <v-list-item>
         
            <v-btn router :to='"/document/"+this.$route.params.id'
      color="blue-darken-4" class="text-none ms-4 text-white">
      <v-icon
        size="small"
        class="me-2"
        
      >
        mdi-pencil
      </v-icon>
      Documents
    </v-btn>
        </v-list-item>
        <v-list-item>
            <v-btn router :to='"/constantes/"+this.$route.params.id'
      color="blue-darken-4" class="text-none ms-4 text-white">
      Transmission
    </v-btn>
        </v-list-item>
        </v-list>
    
    
    </v-container>
    </v-card-text>
    </v-card-item>
    </v-card>
</template>
<script>

export default {
  name: 'App',
  components:{
  //  FormPersonne,
    // FormConstante,
    // FormDocument,
    // Envoyer
   
  },
  data(){
    return {
     
     
    }
}
}
</script>